import type { SVGProps } from "react";
export interface DryerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DryerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DryerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 5c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v14c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 14A4.125 4.125 0 0 1 18 23.125H6A4.125 4.125 0 0 1 1.875 19V5A4.125 4.125 0 0 1 6 .875h12A4.125 4.125 0 0 1 22.125 5z"
      />
      <path
        fill={color}
        d="M16.375 13a4.376 4.376 0 1 0-8.752.001 4.376 4.376 0 0 0 8.752 0Zm-3.03-.839a3.03 3.03 0 0 1 1.807-.24l.045.007a1.126 1.126 0 0 1-.394 2.216l-.045-.008a.8.8 0 0 0-.453.06c-.118.056-.134.103-.124.082l-.243.701c-.232.664-.757 1.111-1.284 1.36a3.03 3.03 0 0 1-1.569.272l-.237-.032-.045-.007.197-1.108.197-1.109.045.01.119.01a.8.8 0 0 0 .334-.07.4.4 0 0 0 .123-.084l.245-.7.1-.24c.263-.533.722-.902 1.183-1.12Zm-3.453 3.106a1.126 1.126 0 0 1 1.305-.912l-.394 2.217a1.126 1.126 0 0 1-.911-1.305m1.453-5.606a3.03 3.03 0 0 1 1.807-.24l.044.008.113.025a1.125 1.125 0 0 1-.391 2.205l-.114-.015-.046-.007a.8.8 0 0 0-.454.058c-.116.055-.133.101-.124.084l-.243.7c-.232.664-.755 1.112-1.282 1.36a3.03 3.03 0 0 1-1.57.272l-.236-.032-.046-.008-.113-.026a1.125 1.125 0 0 1 .393-2.203l.114.014.044.008.119.011a.8.8 0 0 0 .335-.07.35.35 0 0 0 .123-.085l.245-.699.1-.24c.262-.533.721-.903 1.182-1.12M6.64 4.132a1.375 1.375 0 1 1-1.509 1.51L5.125 5.5l.007-.14A1.375 1.375 0 0 1 6.5 4.125l.141.007Zm11.984 8.869a6.625 6.625 0 1 1-13.25-.003 6.625 6.625 0 0 1 13.25.003"
      />
    </svg>
  );
}
